module.exports = __webpack_public_path__ + "static/media/calibrib.8c8905b9.ttf";